import React from 'react'
import { ResponsiveView } from '@/components/ui'
import { LandingBlockContainer } from '..'
import { LandingConditionsDesktop, LandingConditionsMobile } from './components'
import type { IConditionsProps } from './interfaces'
import './styles.scss'

const LandingConditions: React.FC<IConditionsProps> = props => {
  const { title, blockId: gtmBlockId } = props

  return (
    <LandingBlockContainer
      title={title}
      className="landing-constructor-conditions-content space-holder56-sm"
      titleClassName="space-holder40-from-sm space-holder32-sm"
    >
      <div className="landing-constructor-conditions wide-mobile-block">
        <ResponsiveView Desktop={LandingConditionsDesktop} Mobile={LandingConditionsMobile} componentsProps={props} />
      </div>
      <span id={gtmBlockId} />
    </LandingBlockContainer>
  )
}

export default LandingConditions
